import api from "./Api";

class EstoqueVariacaoService {
  GetEstoqueVariacao(payload) {
    return api.get("/v1/estoqueVariacao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEstoqueVariacao(payload) {
    return api.post("/v1/estoqueVariacao/", payload).then((response) => {
      return response.data;
    });
  }

  PutEstoqueVariacao(payload) {
    return api.put("/v1/estoqueVariacao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEstoqueVariacao(payload) {
    return api.delete("/v1/estoqueVariacao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEstoqueVariacaoOData(payload) {
    return api.get("/OData/EstoqueVariacao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EstoqueVariacaoService();
